import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
// import useAxiosFile from "../../../actions/useaxios";
import {
  EncryptData,
  isEmpty,
  LoadToast,
  updateToast,
} from "../../actions/common";
import { Link } from "react-router-dom";
// import Exportcsv from "../Managementpages/Exportcsv";
import { data } from "jquery";
import useAxiosFile from "../../actions/useaxios";
function Coupons() {
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );
  const [selectedOption, setSelectedOption] = useState(null);
  const [rightside, setRightSide] = useState(null);
  const [exportdata, setExportdata] = useState([]);
  const axiosFile = useAxiosFile();
  const [search, setsearch] = useState("");

  const [Drivers, SetDrivers] = useState([]);
  const navigate = useNavigate();
  // const location = useLocation();
  // const state = location.state;
  // console.log("statryeeee",state,location);

  const Delete = async (_id) => {
    let Resp = await axiosFile.getCouponList({ _id: _id, action: "delete" });
    GetDrivers()
  }
  useEffect(() => {
    if (payload?._id) {
      getshop();
    }
  }, [payload?._id]);
  const [shoplist, SetShopList] = useState([]);
  const [SelectedShop, SetSelectedShop] = useState({});

  const getshop = async () => {
    let Resp = await axiosFile.getshop({
      SellerId: payload?._id,
      from: "sel_cat",
    });
    SetShopList(Resp?.data);
    console.log("slkjdlksfsf", Resp, payload);
    SetSelectedShop(Resp?.data?.[0]);
  };

  useEffect(() => {

    GetDrivers();
  }, [SelectedShop?._id]);



  const GetDrivers = async () => {
    let Resp = { data: [] };
    if (SelectedShop?._id) {
      Resp = await axiosFile.CouponList({
        ShopId: SelectedShop?._id,
        from: 'particular'
      });
    }
    // let Resp = await axiosFile.CouponList();
    console.log("sd", Resp);
    SetDrivers(Resp?.data);
  }

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const subdetailbutton = async (e, data) => {
    let id = LoadToast();

    let cell = {
      id: data._id,
      check: e.target.checked,
    };
    console.log("datsssss", data, e.target.checked);
    var data = await axiosFile.couponsend(cell);
    console.log("eFCSEfddfbdvf", data);
    updateToast(id, data.msg, data.success);
    if (data.success == "success") {
      console.log("statusdata", data.status);
      GetDrivers();
    }
  };

  const ApproveBtn = async (_id, data) => {
    let id = LoadToast();
    let Resp = await axiosFile.getCouponList({ _id, action: "approve", approve: data, ShopId: SelectedShop?._id });
    updateToast(id, Resp.msg, Resp.success);
    GetDrivers()

  }

  const columns = [
    {
      dataField: "hash", text: "#", formatter: (cell, row, rowindex) => (
        <div>{rowindex + 1}</div>
      )
    },
    {
      dataField: "CouponType", text: "Coupon Type", formatter: (cell, row, rowindex) => (
        <div>
          {row?.CouponType=="1storder"?"Default":(row?.CouponType=="above"?"Flat Deal":row?.CouponType)}
        </div>
      )
    },
    { dataField: "CouponCode", text: "offer Code", sort: true },
    { dataField: "CouponTitle", text: "Title", sort: true },
    { dataField: "Expiry", text: "Expiry", sort: true },
    {
      dataField: "Discount", text: "Discount", formatter: (cell, row, rowindex) => (
        <div>
          {row?.Value}{row?.DiscountValue=="percentage"?" %":""}
        </div>
      )
    },
    {
      dataField: "ApprovedShop", text: "Approve/Reject", formatter: (cell, row) => (

        <button
          className="seller_theme_btn"
          disabled={row.CouponType == "1storder" ? true : false}
          onClick={() =>
            cell?.some(it => it == SelectedShop?._id) == false ?
              ApproveBtn(row?._id, "approve") :
              ApproveBtn(row?._id, "reject")
          }
        >
          {
            row.CouponType == "1storder" ? "Default Coupon" :
              cell?.some(it => it == SelectedShop?._id) == false ? "Approve" : "Reject"}
        </button>

      ),
    },



  ];

  return (
    <>
      <section id="content-wrapper">
        {/* <div class="row"> */}
        <div className="top_title_sec">
          <div>
            <p className="page_title">Coupons</p>
          </div>
          <div className="mm_searchdrop_align">


            <div className="top_two_dropdowns">
              <DropdownButton
                title={SelectedShop?.BrandName}
                onSelect={(e) =>
                  SetSelectedShop(JSON.parse(e))
                }
              >
                {shoplist.map((it) => {
                  return (
                    <Dropdown.Item
                      eventKey={JSON.stringify(it)}
                    >
                      {it.BrandName}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>


            </div>
          </div>

        </div>
        {/* </div> */}
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row">

              <div className="col-xxl-8 col-xl-8 col-lg-9 col-md-9 col-sm-12 col-12">

              </div>
              <div className="ffd_table mar_bot">
                <BootstrapTable
                  bootstrap4
                  keyField="id"
                  columns={columns}
                  data={Drivers}
                  pagination={pagination}
                  noDataIndication="No Coupons found"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Coupons;
